<template>
  <div class="game-parent">
    <a
      :href="'https://store.steampowered.com/app/' + game.appid"
      target="_blank"
    >
      <!-- <img :src="game.logo_url"> -->
      <img
        :src="`https://steamcdn-a.akamaihd.net/steam/apps/${game.appid}/header.jpg`"
        alt=""
        class=""
      />
    </a>
    <p>{{ game.name }}</p>
  </div>
</template>

<script>
export default {
  name: "Game",
  props: {
    game: {
      type: Object,
      default: null,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.game-parent {
  margin-bottom: 1em;
  margin-right: 0.5em;
}
.game-parent p {
  font-size: 14px;
  font-weight: 200;
  overflow: hidden;
  max-width: 184px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.game-parent img {
  width: 184px;
  height: 86px;
}
</style>